<template>
  <!-- Table Container Card -->
  <b-card
    no-body
  >

    <div class="m-2">

      <!-- Table Top -->
      <b-row>

        <!-- Per Page -->
        <b-col md="12">
          <h5 class="section-label mb-3">
            {{ $t('Recompute Loan Status') }}
          </h5>
        </b-col>
        <b-col
          md="12"
          class="align-items-center justify-content-start mb-1 mb-md-0"
        >
          <validation-observer ref="recomputeLoanStatusRef">
            <b-form>
              <b-row class="match-height">

                <!-- Financial Date From-->
                <b-col md="6">
                  <DatePickerField
                    id="financial-date-from"
                    v-model="recomputeLoanStatus.startDate"
                    rules="required"
                    :min-date="new Date()"
                    :label="$t('Financial Date From')"
                    :error-name="$t('Financial Date From')"
                    :config="datePickerConfig"
                    :placeholder="$t('Select Date')"
                    :disabled="isDisabledText === true"
                  />
                </b-col>
                <!--  Financial Date From-->

                <!-- Financial Date To-->
                <b-col md="6">
                  <DatePickerField
                    id="financial-date-to"
                    v-model="recomputeLoanStatus.endDate"
                    rules="required"
                    :min-date="new Date()"
                    :label="$t('Financial Date To')"
                    :error-name="$t('Financial Date To')"
                    :config="datePickerConfig"
                    :placeholder="$t('Select Date')"
                    :disabled="isDisabledText === true"
                  />
                </b-col>
                <!--  Financial Date To-->
              </b-row>

              <b-row>
                <b-col>
                  <Button
                    v-if="getUserPermission('RECOMPUTE_EOD_BALANCE')"
                    :label="$t('Recompute Loan Status')"
                    size="md"
                    class="mt-2"
                    :loading="isLoading"
                    :disabled="isDisabled"
                    @click="handleSubmit"
                  />
                </b-col>
              </b-row>
            </b-form>
          </validation-observer>
        </b-col>
      </b-row>
    </div>

    <FullScreenSpinner :show="showSpinner" />
  </b-card>

</template>

<script>
import {
  BCard, BRow, BCol, BForm, VBTooltip,
} from 'bootstrap-vue'
import { required, positive } from '@validations'
import { ValidationObserver } from 'vee-validate'
import { modalMixins } from '@core/mixins/modal'
import { tableMixins } from '@core/mixins/table'
import { sweetAlert } from '@core/mixins/sweetAlert'
import { mapActions, mapGetters } from 'vuex'
import { permissionMixin } from '@core/mixins/permission'
import FullScreenSpinner from '@/views/components/spinner/FullScreenSpinner.vue'
import Button from '../../../components/button/Button.vue'
import { operationPermissions } from '../../../../helpers/permissions'
import { getMinusOneDayDate } from '@/helpers/formatDate'
import DatePickerField from '../../../forms/DatePickerField.vue'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BCard,
    BRow,
    BCol,
    Button,
    BForm,
    ValidationObserver,
    FullScreenSpinner,
    DatePickerField,
  },
  mixins: [modalMixins, tableMixins, sweetAlert, permissionMixin],
  data() {
    return {
      isBusy: true,
      showSpinner: false,
      isLoading: false,
      isDisabled: false,
      required,
      positive,
      recomputeLoanStatus: {
        startDate: null,
        endDate: null,
      },
      datePickerConfig: {
        dateFormat: 'Y-m-d',
        maxDate: '',
        defaultDate: '',
      },

    }
  },
  computed: {
    ...mapGetters({
      currentFinancialDate: 'operations/getCurrentFinancialDate',
    }),
    getPreviousFinancialDates() {
      return getMinusOneDayDate(this.currentFinancialDate.financialDate)
    },
  },
  mounted() {
    this.datePickerConfig.maxDate = this.getPreviousFinancialDates
  },
  methods: {
    ...mapActions({
      postRecomputeLoanStatus: 'posting/recomputeLoanStatusAction',
    }),

    handleSubmit() {
      this.$refs.recomputeLoanStatusRef.validate().then(success => {
        if (success) {
          this.confirm(this.recomputeLoanStatusAction, { text: this.$t('You are about to Recompute Loan Status! Are you sure?') })
        }
      })
    },
    async recomputeLoanStatusAction() {
      try {
        this.isLoading = true
        this.showSpinner = true
        this.isDisabled = true
        const formData = {
          ...this.recomputeLoanStatus,
        }
        const response = await this.postRecomputeLoanStatus({ formData, permission: operationPermissions.RECOMPUTE_EOD_BALANCE })
        const { status } = response
        if (status === 200) {
          this.alertSuccess({ text: this.$t('Your Recompute Loan Status request was successful') })
          this.resetInputField()
          this.showSpinner = false
        }
      } catch (error) {
        this.handleError(error)
      } finally {
        this.isLoading = false
        this.isDisabled = false
        this.showSpinner = false
      }
    },
    resetInputField() {
      this.recomputeLoanStatus = {
        startDate: null,
        endDate: null,
      }
      this.isLoading = false
      this.isDisabled = false
    },
  },
}
</script>

<style scoped>
.message-counter {
  margin-left: 15px;
  margin-top: -10px;
  text-align: right;
}
.tooltip::v-deep .tooltip-inner {
  max-width: 22em;
}
/* .toolkit-format {
  margin-left: -45px;
} */
</style>
